import { WPSimplePage } from 'types/pages';
import { useApiRequest } from './useApiRequest';

type UsePages = {
  readonly slug?: string;
  readonly skip?: boolean;
  readonly per_page?: number;
};

const endpoint = 'pages';

export const usePages = <T extends WPSimplePage>(options?: UsePages) => {
  const { slug, skip, ...restOptions } = options || {};
  return useApiRequest<T[]>({
    slug,
    skip,
    fields: 'date,status,modified,type,acf,id,title,content,yoast_meta,yoast_title,yoast_json_ld,yoast_head,slug,_links,wpml_translations',
    endpoint,
    cacheKey: `page:${slug}`,
    options: restOptions,
    embed: false,
  });
};

export const useAllPages = <T extends WPSimplePage>(options?: UsePages) => {
  const { slug, skip, ...restOptions } = options || {};
  return useApiRequest<T[]>({
    skip,
    fields: 'date,status,modified,type,acf,id,title,content,yoast_meta,yoast_title,yoast_json_ld,yoast_head,slug,_links,wpml_translations',
    endpoint,
    cacheKey: `pages`,
    options: restOptions,
    embed: false,
  });
};

export const useAllSimplePages = <T extends WPSimplePage>(options?: UsePages) => {
  const { slug, skip, ...restOptions } = options || {};
  return useApiRequest<T[]>({
    skip,
    fields: 'date,status,modified,type,acf,id,title,content,yoast_meta,yoast_title,yoast_json_ld,yoast_head,slug,_links,wpml_translations',
    endpoint,
    cacheKey: `pages`,
    options: restOptions,
    embed: false,
  });
};
